module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.RouteFromBiblio) ? _c('div', {
    staticClass: "backToBiblio",
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "id": "backToBiblio"
    },
    on: {
      "click": function($event) {
        return _vm.backToBiblioSegment()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "100px",
      "height": "30px",
      "viewBox": "0 0 100 30",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', [_c('rect', {
    attrs: {
      "stroke": "#FFFFFF",
      "stroke-width": "1",
      "x": "0.5",
      "y": "0.5",
      "width": "99",
      "height": "29",
      "rx": "6"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(16.000000, 7.000000)",
      "fill": "#FFFFFF",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.1714286,7.71428571 L5.29714286,7.71428571 L7.67314286,5.33828571 C7.87577143,5.13565714 7.97142857,4.89394286 7.97142857,4.62857143 C7.97142857,4.12251429 7.55331429,3.6 6.94285714,3.6 C6.66977143,3.6 6.43165714,3.69925714 6.23314286,3.89828571 L2.14045714,7.99097143 C1.97177143,8.15965714 1.8,8.36794286 1.8,8.74285714 C1.8,9.11777143 1.94348571,9.29828571 2.13222857,9.48702857 L6.23314286,13.5874286 C6.43165714,13.7864571 6.66977143,13.8857143 6.94285714,13.8857143 C7.55382857,13.8857143 7.97142857,13.3632 7.97142857,12.8571429 C7.97142857,12.5917714 7.87577143,12.3500571 7.67314286,12.1474286 L5.29714286,9.77142857 L15.1714286,9.77142857 C15.7392,9.77142857 16.2,9.31062857 16.2,8.74285714 C16.2,8.17508571 15.7392,7.71428571 15.1714286,7.71428571 Z",
      "id": "Path"
    }
  })]), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "RobotoUep!important",
      "font-size": "13",
      "font-weight": "700",
      "letter-spacing": "-0.336",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "39",
      "y": "20"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.back')))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel__title_page",
    class: {
      'edit-mode': _vm.isEditMode,
      'back-route': _vm.RouteFromBiblio
    },
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "id": "panel__title_page"
    }
  }, [(!_vm.isSegment && !_vm.isEditMode) ? _c('div', {
    staticClass: "show-panel"
  }, [_c('span', {
    staticClass: "show-panel__span"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-pencil panel__title_edit",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeTemplate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEditMode && _vm.isSegment) ? _c('div', {
    staticClass: "show-panel"
  }, [_c('span', {
    staticClass: "show-panel__span"
  }, [_vm._v(_vm._s(_vm.titleSegment))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-pencil panel__title_edit",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeSegment()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSegment),
      expression: "!isSegment"
    }],
    staticClass: "edit-panel"
  }, [_c('div', {
    staticClass: "save-btn fa fa-save",
    on: {
      "click": function($event) {
        return _vm.updateTemplate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn fa fa-times-circle",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeTemplate(true)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "title": _vm.$t('panels.title'),
      "placeholder": _vm.$t('panels.title'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegment),
      expression: "isSegment"
    }],
    staticClass: "edit-panel"
  }, [_c('div', {
    staticClass: "save-btn fa fa-save",
    on: {
      "click": function($event) {
        return _vm.updateSegment()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn fa fa-times-circle",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeSegment(true)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleSegment),
      expression: "titleSegment"
    }],
    staticClass: "form-control",
    attrs: {
      "title": _vm.$t('panels.title'),
      "placeholder": _vm.$t('panels.title'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.titleSegment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleSegment = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d42cc96","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelTitlePages.vue
// module id = 822
// module chunks = 1 3